import { Component, EventEmitter, Input, Output } from '@angular/core';

import { EntityKeys } from '@config/keys/entity.keys';

import { DoodEntityModel } from '@core/models/entity.model';
import { IContentBuilderFieldImage } from '@core/models/content-builder-fields.model';
import {
  EntityCategoryBadgeSource,
  resolveEntityCategoryBadge,
} from '@shared/utils/entity-category-badge/entity-category-badge.utils';
import { resolveEntityDisplayName } from '@shared/utils/entity-display-name/entity-display-name.utils';

@Component({
  selector: 'app-shop-card-logo-atom',
  templateUrl: './shop-card-logo-atom.component.html',
  standalone: false,
})
export class ShopCardLogoAtomComponent {
  @Input() entity?: DoodEntityModel;
  @Input() isMarketplaceAvailable = true;
  @Input() shopImage!: string;
  @Input() uploadedImage!: IContentBuilderFieldImage;
  @Input() entityName!: string;
  @Input() entityCategory!: string;
  @Input() displayEntityImage = true;
  @Input() displayEntityCategory = true;
  @Input() entityCategoryBadgeSource: EntityCategoryBadgeSource = 'subcategory';

  @Output() navigationClick = new EventEmitter<DoodEntityModel>();

  get resolvedEntityName(): string {
    return resolveEntityDisplayName({
      override: this.entityName,
      entityName: this.entity?.[EntityKeys.Name],
    });
  }

  get resolvedCategoryBadge(): string {
    return resolveEntityCategoryBadge({
      override: this.entityCategory,
      category: this.entity?.[EntityKeys.Type]?.[EntityKeys.Name] ?? '',
      shortDescription: this.entity?.[EntityKeys.ShortDescription] ?? '',
      badgeSource: this.entityCategoryBadgeSource,
    });
  }
}
